import { Wording } from '@/types';

export const COOKING_WORDING_EN: Wording = {
  components_header_media_content: 'Cooking videos',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recipes',
  components_header_text2: 'Blog',
  components_header_members: 'Members',
  hero_text: 'Cook With Passion, Eat With Joy',
  hero_button_text: 'Start Cooking Today',
  components_ressources_section_title: 'RESOURCES',
  components_ressources_subheader_text: 'All the Resources You Need to Learn, Cook, and Create Better Food',
  components_ressources_span_text: 'Discover a Rich Collection of Video Recipes, Detailed Cooking Guides, and Expert Insights on Flavor Pairing, Food Presentation, and Culinary Creativity.',
  components_ressources_card_1_title: 'Cooking Inspiration',
  components_ressources_card_1_text: 'Get inspired by creative recipes and cooking videos.',
  components_ressources_card_2_title: 'Cooking Knowledge',
  components_ressources_card_2_text: 'Learn essential cooking techniques, flavor combinations, and food pairing basics through clear, practical guides.',
  components_ressources_link: 'Watch Videos',
  components_notes_and_google_title_1: 'Cooking Education',
  components_notes_and_google_title_2: 'Everyday Cooking',
  components_notes_and_google_title_3: 'Consistent Cooking Skills',
  components_review_google_text: 'Reviews on Google',
  media_content_section_title: 'Cooking videos',
  media_content_section_subheader_text: 'Explore recipes and step-by-step cooking videos.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'More Videos',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Guides & Articles',
  text2_section_button_more: 'More Articles',
  components_text1_section_title: 'RECIPES',
  components_text1_subheader_text: 'Delicious Recipes for Everyday Cooking',
  components_text1_span_text: 'Discover easy-to-follow recipes designed for everyday meals, clear steps, and great results.',
  components_text1_card_1_title: 'Start Your Day Right',
  components_text1_card_1_text: 'Simple and tasty recipes to begin your day with ease and flavor.',
  components_text1_card_3_title: 'Flavorful Lunch Ideas',
  components_text1_card_3_text: 'Delicious lunch recipes that are easy to prepare and full of flavor.',
  components_text1_card_2_title: 'Comforting Dinner Recipes',
  components_text1_card_2_text: 'Warm, satisfying dinner recipes perfect for relaxed evenings at home.',
  components_text1_link: 'View all recipes',
  components_footer_text: 'Learn Better Cooking, Create Better Food: Your Kitchen, Your Journey.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registration number',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Terms and Conditions',
  components_footer_privacy: 'Privacy Policy',
  button_load_more: 'Load More',
  page_media_1_content_hero_text: 'Discover easy cooking videos for every taste',
  page_text1_hero_text: 'Recipes',
  page_text1_section_title: 'Cooking Tips',
  page_text1_subheader_text: 'Recipes',
  page_text2_hero_text: 'Our Blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Guides & Articles',
  enter_email_title: 'Please enter your email to continue',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Login successful!',
  components_card_link_media_content: 'Watch Now',
  components_card_link_text1_content: 'View Recipe',
  components_card_link_text2_content: 'View Article',
};